import numeral from "numeral";
import { ICompany, IPoInput } from "../models/rmm_models";
import { IOrderLine,ITcCompany } from "../../orders/models/order";
import QRCode from "qrcode";
import { IFcdOrder } from "../models/yarn";
import { PieceDyeFormData } from "../../fcd/models/piecedye.models";
export const getInitialState = (type: string = "Yarn"): IPoInput => ({
  id: 0,
  type,
  owner_id: type==="yarn"? 0 : 1,
  id_order_type: 0,
  orderhead_id: [],
  sales_id: 0,
  supplier_id: null,
  supplier_type_location_id: 0,
  destination_id: 0,
  deliver_id: 0,
  estimated_delivery_date: null,
  latest_date_shippment: null,
  payment_term_id: 0,
  shipping_mode_id: 0,
  incoterm_id: 0,
  moisture: 0,
  color_fastness: false,
  items: [],
  order_status: undefined,
  remark_request_edit: "",
  file: [],
  editable: false,
  orderpo_id: "",
  tc_certification: [],
  request_edit:false,
});
export const generateQrBase64 = async (value: string) => {
  return await QRCode.toDataURL(value, {
    margin: 1,
    width: 120,
  });
};
export function transformPoData(type: "Yarn" | "Acc" | "Lsp", poData: any,tc_certification:ITcCompany[]|undefined,all_companies:ICompany[] | undefined) {
  const companyId = all_companies?.find((company) => company.code === "AK");
  switch (type) {
    case "Yarn":
      return {
        id: poData?.id ?? 0,
        type: "Yarn",
        items:
          poData?.yarn?.map((item: any) => ({
            ...item,
            item_details: item.yarn_details.map((det: any) => ({
              ...det,
              yarn_id:item.id,
              isSelected: false,
              quantity_order: numeral(det.quantity_order).value() ?? 0,
            })),
          })) ?? [],
        yarn: poData?.yarn,
        owner_id: poData?.owner_id ?? 0,
        id_order_type: poData?.order_type?.id ?? 0,
        orderhead_id: poData?.orderhead_id ?? [],
        orderpo_id: poData?.orderpo_id ?? "",
        sales_id: poData?.sales_id ?? 0,
        supplier_id: poData?.supplier?.id ?? 0,
        supplier_type_location_id: poData?.supplier_type_location?.id ?? 0,
        destination_id: poData?.destination?.id ?? poData?.destination_id ?? 0,
        deliver_id: poData?.deliver?.id ?? poData?.deliver_id ?? 0,
        payment_term_id: poData?.payment_term_details?.id ?? poData?.payment_term_id ?? 0,
        estimated_delivery_date: poData?.estimated_delivery_date ?? null,
        latest_date_shippment: poData?.latest_date_shippment ?? null,
        shipping_mode_id: poData?.shipping_mode?.id ?? poData?.shipping_mode_id ?? 0,
        incoterm_id: poData?.incoterm?.id ?? poData?.incoterm_id ?? 0,
        moisture: poData?.moisture ?? 0,
        color_fastness: poData?.color_fastness ?? false,
        order_status: poData?.order_status ?? undefined,
        remark_request_edit: poData?.remark_request_edit ?? "",
        request_edit:poData?.request_edit ?? false,
        file: poData?.file ?? [],
        editable: poData?.editable,
        tc_certification: poData?.order_type?.id !==3
          ? poData?.tc_certification
          : poData?.order_details?.flatMap(
              (det: { tcCompanies: Array<{ id: string | number }> }) =>
                det.tcCompanies.map((tc) => tc.id)
            ),
        tcCompanies:poData?.order_type?.id !==3
        ? tc_certification?.filter((tc)=>
        (poData?.tc_certification ?? [] ).includes(String(tc.id))
        )
        : poData?.order_details?.flatMap(
            (det: { tcCompanies: any[] }) => det.tcCompanies
          ) ?? [],
      };
    case "Acc":
      return {
        id: poData?.id ?? 0,
        type: "Acc",
        items:
          poData?.acc?.map((item: any) => ({
            ...item,
            item_details:item.acc_details.map((det:any)=>({
              ...det,
              acc_id:item.id,
              isSelected:false,
              quantity_order: numeral(det.quantity_order).value() ?? 0,

            })),
           })) ?? [],
        acc: poData?.acc,
        owner_id: Number(companyId?.id) ?? 1,
        id_order_type: poData?.order_type?.id ?? 0,
        orderhead_id: poData?.orderhead_id ?? [],
        orderpo_id: poData?.orderpo_id ?? "",
        sales_id: poData?.sales_id ?? 0,
        supplier_id: poData?.supplier?.id ?? 0,
        supplier_type_location_id: poData?.supplier_type_location?.id ?? 0,
        destination_id: poData?.destination?.id ?? poData?.destination_id ?? 0,
        deliver_id: poData?.deliver?.id ?? poData?.deliver_id ?? 0,
        estimated_delivery_date: poData?.estimated_delivery_date ?? null,
        latest_date_shippment: poData?.latest_date_shippment ?? null,
        payment_term_id: poData?.payment_term_details?.id ?? poData?.payment_term_id ?? 0,
        shipping_mode_id: poData?.shipping_mode?.id ?? poData?.shipping_mode_id ?? 0,
        incoterm_id: poData?.incoterm?.id ?? poData?.incoterm_id ?? 0,
        moisture: poData?.moisture ?? 0,
        color_fastness: poData?.color_fastness ?? false,
        order_status: poData?.order_status ?? undefined,
        remark_request_edit: poData?.remark_request_edit ?? "",
        file: poData?.file ?? [],
        editable: poData?.editable,
       request_edit:poData?.request_edit ?? false,
      };
    case "Lsp":
      return {
        id: poData?.id ?? 0,
        type: "Lsp",
        items:
          poData?.lsp?.map((item: any) => ({
            ...item,
            isSelected: false,
            item_details: item.lsp_details.map((det: any) => ({
              ...det,
              lsp_id:item.id,
              isSelected: false,
              quantity_order: numeral(det.quantity_order).value() ?? 0,
            })),
          })) ?? [],
        lsp: poData?.lsp,
        owner_id: poData?.owner_id ?? 1,
        id_order_type: poData?.order_type?.id ?? 0,
        orderhead_id: poData?.orderhead_id ?? [],
        orderpo_id: poData?.orderpo_id ?? "",
        sales_id: poData?.sales_id ?? 0,
        supplier_id: poData?.supplier?.id ?? 0,
        supplier_type_location_id: poData?.supplier_type_location?.id ?? 0,
        destination_id: poData?.destination?.id ?? poData?.destination_id ?? 0,
        deliver_id: poData?.deliver?.id ?? poData?.deliver_id ?? 0,
        estimated_delivery_date: poData?.estimated_delivery_date ?? null,
        latest_date_shippment: poData?.latest_date_shippment ?? null,
        payment_term_id: poData?.payment_term_details?.id ?? poData?.payment_term_id ?? 0,
        shipping_mode_id: poData?.shipping_mode?.id ?? poData?.shipping_mode_id ?? 0,
        incoterm_id: poData?.incoterm?.id ?? poData?.incoterm_id ?? 0,
        moisture: poData?.moisture ?? 0,
        color_fastness: poData?.color_fastness ?? false,
        order_status: poData?.order_status ?? undefined,
        remark_request_edit: poData?.remark_request_edit ?? "",
        request_edit:poData?.request_edit ?? false,
        file: poData?.file ?? [],
        editable: poData?.editable ?? false,
      };
    default:
      return {};
  }
}
export function toOrderLine(input: any): IOrderLine {

  return {
    id: input.id ?? 0,
    order_id: input.order_id ?? "",
    orderhead_id: input.orderhead_id ?? 0,
    style_description: input.style_description ?? "",
    machine_type: input.machine_type ?? "",
    style_code: input.style_code ?? "",
    shipment: input.shipment ?? "",
    sample_ref: input.sample_ref ?? "",
    csn: input.csn ?? "",
    terms: input.terms ?? "",
    status: input.status ?? "",
    customer_order_number: input.customer_order_number ?? null,
    factory1: input.factory1 ?? "",
    factory2: input.factory2 ?? "",
    csb: input.csb ?? 0,
    gg: input.gg ?? "",
    quantity: input.quantity ?? 0,
    cmt_price: input.cmt_price ? String(input.cmt_price) : null,
    factory_cmt: String(input.factory_cmt ?? 0),
    contract_weight: String(input.contract_weight ?? 0),
    approval_weight: input.approval_weight ?? 0,
    avg_weight: input.avg_weight ?? 0,
    wastage: input.wastage ?? 0,
    orderhead_totalQuantity: input.orderhead_totalQuantity ?? 0,
    orderhead_totalValue: input.orderhead_totalValue ?? 0,
    quantity_shipped: input.quantity_shipped
      ? String(input.quantity_shipped)
      : null,
    price: String(input.price ?? 0),
    flex_bs_price: String(input.flex_bs_price ?? 0),
    request_date: input.request_date ?? null,
    proposed_date: input.proposed_date ?? null,
    oc_date: input.oc_date ?? null,
    ppa: input.ppa ?? null,
    kpa: input.kpa ?? null,
    segment:
      typeof input.segment === "string"
        ? { id: 0, sort : input.segment, title:input.segment, active:1 } // placeholder object
        : input.segment,
    sort:
      typeof input.sort === "string"
        ? { id: 0, sort: input.sort,title:input.sort, active:1 }
        : input.sort,
    invoiceLine: input.invoiceLine ?? "",
    orderhead: input.orderhead as any, // cast if needed
    shoulder:
      typeof input.shoulder === "string"
        ? { id: 0, description: input.shoulder, title: input.shoulder, active:true }
        : input.shoulder,
    collar:
      typeof input.collar === "string"
        ? { id: 0, description: input.collar, title:input.collar, active:true }
        : input.collar,
    stich:
      typeof input.stich === "string"
        ? { id: 0, description: input.stich, title:input.stich, active:true }
        : input.stich,
    pocket:
      typeof input.pocket === "string"
        ?{ id: 0,description: input.pocket, title:input.pocket, active:true  }
        : input.pocket,
    sleeve:
      typeof input.sleeve === "string"
        ? { id: 0,description: input.sleeve, title:input.sleeve, active:true  }
        : input.sleeve,
    // client: input.customer_code || input.customer_name
    //   ? {
    //       id: 0,
    //       : input.customer_code ?? "",
    //       name: input.customer_name ?? "",
    //     }
    //   : undefined,
    custom_field_style: input.custom_field_style ?? [],
  };
}
  export const weight_unit = [
    { id: 1, label: "Kgs", value: "1" },
    { id: 2, label: "Lbs", value: "2" },
  ];

  export const formatFcdOrderData = (orders: IFcdOrder[]) => {
    console.log("formatFcdOrderData input:", orders)
    return orders.map((order) => ({
      id: order.id,
      label: order.orderpo_id,
      value: order.orderpo_id,
    }));
  };

  export const formatPieceDyeOrderData = (orders: PieceDyeFormData[]) => {
  return orders.map((order, index) => ({
    id: Number(order.orderId)|| index,
    label: order.fcd_ref || `PDPO-${order.orderId}`,
    value: order.fcd_ref || order.orderId,
  }));
};
export const formatFr = (value: number | string): string => {
  const formatted = numeral(value).format("0,0.00");
  const [intPart, decPart] = formatted.split(".");
  return `${intPart.replace(/,/g, ".")},${decPart}`;
};